import { Linkedin } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";
import { SectionShell, Eyebrow } from "@/components/site/Primitives";

const FOUNDER_LINKEDIN = "https://www.linkedin.com/in/moustaka/";

const POINTS = [
  "Global maritime and trade orientation",
  "International connectivity and specialist talent",
  "Enterprise-grade product and engineering discipline",
  "Long-term commercial infrastructure ambition",
];

export function About() {
  return (
    <SectionShell id="about" tone="white">
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-2 lg:gap-20">
        <Reveal>
          <div>
            <Eyebrow color="gold">About</Eyebrow>
            <h2 className="display mt-6 text-3xl text-natsu-navy sm:text-4xl">
              Built for global maritime trade.
            </h2>
            <p className="mt-6 measure text-base leading-relaxed text-natsu-slate">
              NATSU Intelligence is being developed at the intersection of
              maritime commerce, enterprise technology, capital and global trade.
            </p>
            <ul className="mt-8 space-y-3">
              {POINTS.map((t) => (
                <li key={t} className="flex items-start gap-3 text-[15px] text-natsu-navy/80">
                  <span className="mt-2 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-natsu-gold" />
                  {t}
                </li>
              ))}
            </ul>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="rounded-2xl border border-natsu-navy/10 bg-natsu-mist p-8 sm:p-10">
            <Eyebrow color="purple">Founder</Eyebrow>
            <h3 className="display mt-6 text-2xl text-natsu-navy">Anne-Marie Moustaka</h3>
            <p className="mt-1 text-sm font-medium text-natsu-slate">Founder &amp; CEO</p>
            <p className="mt-6 measure text-base leading-relaxed text-natsu-slate">
              Anne-Marie is a commercial strategist and technology consultant with
              experience navigating complex, data-intensive enterprise environments.
              She founded NATSU Intelligence to transform fragmented maritime and
              trade information into explainable, decision-ready commercial
              intelligence.
            </p>
            <div className="mt-6 border-t border-natsu-navy/10 pt-6">
              <p className="eyebrow text-natsu-slate">Founder focus</p>
              <p className="mt-3 text-[15px] leading-relaxed text-natsu-navy/80">
                Commercial Strategy · Enterprise Technology · Product Vision ·
                Decision Governance
              </p>
              <a
                href={FOUNDER_LINKEDIN}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="founder-linkedin"
                className="mt-6 inline-flex items-center gap-2 text-[13.5px] font-medium text-natsu-blue transition-colors hover:text-natsu-blue-soft"
              >
                <Linkedin className="h-4 w-4" strokeWidth={1.8} />
                LinkedIn → Anne-Marie Moustaka
              </a>
            </div>
          </div>
        </Reveal>
      </div>
    </SectionShell>
  );
}
